import {
    HOME_ROUTE,
    LOGIN_ROUTE,
    REGISTRATION_ROUTE,
    PLUGINS_ROUTE,
    SERVERS_ROUTE,
    SERVER_PLUGINS_ROUTE,
    CREATE_SERVER,
    CHAT_ROUTE,
    LOG_ROUTE,
    SERVER_DETAILS,
    CONFIRMATION_ROUTE,
    CHAT_PAGE,
    CONFIG_EDIT,
    SERVER_SETTINGS,
    PLUGIN_DETAILS_ROUTE,
    SERVER_SHOP_CATEGORIES,
    SERVER_SHOP_ITEMS, SHOP_ITEMS, SERVER_PLAYERS, WALLET_PLAYER
} from "./utils/consts";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Plugins from "./pages/Plugins";
import Servers from "./pages/Servers";
import ServerPlugins from "./pages/ServerPlugins";
import PluginDetails from "./pages/PluginDetails";
import CreateServer from "./pages/server/CreateServer";
import Chat from "./pages/Chat";
import Log from "./pages/Log";
import ServerDetails from "./pages/ServerDetails";
import EmailConfirmation from "./pages/EmailConfirmation";
import ChatPage from "./pages/ChatPage";
import ConfigEdit from "./pages/ConfigEdit";
import ServerSettings from "./pages/ServerSettings";
import PluginEdit from "./pages/PluginEdit";
import ServerPluginEdit from "./pages/ServerPluginEdit";
import ServerShopCategories from "./pages/ServerShopCategories";
import ServerShopItems from "./pages/ServerShopItems";
import ShopItems from "./pages/ShopItems";
import PlayersPage from "./pages/PlayersPage";
import WalletPage from "./pages/WalletPage";

export const authRoutes = [
    {
        path: PLUGINS_ROUTE,
        Component: Plugins
    },
    {
        path: SERVERS_ROUTE,
        Component: Servers
    },
    {
        path: SERVER_SHOP_CATEGORIES,
        Component: ServerShopCategories
    },
    {
        path: SERVER_SHOP_ITEMS,
        Component: ServerShopItems
    },
    {
        path: WALLET_PLAYER,
        Component: WalletPage
    },
    {
        path: SERVER_PLAYERS + '/:serverId',
        Component: PlayersPage
    },
    {
        path: SHOP_ITEMS + '/:serverId',
        Component: ShopItems
    },
    {
        path: SERVER_PLUGINS_ROUTE + '/:id',
        Component: ServerPlugins
    },
    {
        path: CHAT_ROUTE + '/:server_id',
        Component: ChatPage
    },
    {
        path: LOG_ROUTE + '/:server_id',
        Component: Log
    },
    {
        path: CREATE_SERVER,
        Component: CreateServer
    },
    {
        path: SERVER_SETTINGS + '/:server_id',
        Component: ServerSettings
    },
    {
        path: PLUGIN_DETAILS_ROUTE + '/:plugin_id',
        Component: PluginDetails
    },
    {
        path: SERVER_PLUGINS_ROUTE + '/:server_id/edit/:addition_id/:id',
        Component: ServerPluginEdit
    },
    {
        path: PLUGIN_DETAILS_ROUTE + '/:plugin_id/edit/:addition_id/:filename',
        Component: PluginEdit
    }
];

export const publicRoutes = [
    {
        path: HOME_ROUTE,
        Component: Home
    },
    {
        path: LOGIN_ROUTE,
        Component: Login
    },
    {
        path: REGISTRATION_ROUTE,
        Component: Registration
    },
    {
        path: SERVER_DETAILS + '/:server_id',
        Component: ServerDetails
    },
    {
        path: CONFIRMATION_ROUTE + '/:hash',
        Component: EmailConfirmation
    },
    {
        path: CHAT_PAGE,
        Component: ChatPage
    },
    {
        path: CONFIG_EDIT,
        Component: ConfigEdit
    }
];